export class NavItem {
    constructor(
        public key: string,
        public label: string,
        public disabled: boolean,
        public url: string,
        public completed: boolean
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/core/models/nav-item.ts